import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceininternationaltechpark() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in International Tech Park Chennai (ITPC',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in International Tech Park Chennai (ITPC',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in International Tech Park Chennai (ITPC), catering to the transportation needs of IT companies, corporate offices, and business centers within the park. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and punctual travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around ITPC Chennai.',

    top: 'Top Places to Visit in Chennai with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Marina Beach",
    "description": "Marina Beach is Chennai’s most famous landmark and one of the longest urban beaches in the world, stretching over 13 km along the Bay of Bengal. The beach is popular for morning jogs, evening strolls, kite flying, and street food like sundal, murukku, and fresh coconut water. It also hosts cultural events, festivals, and local gatherings, making it a hub of leisure, social activity, and city life."
  },
  {
    "title": "Kapaleeshwarar Temple",
    "description": "Kapaleeshwarar Temple in Mylapore is a classic example of Dravidian architecture, dedicated to Lord Shiva. Known for its vibrant gopuram, intricate carvings, and peaceful inner sanctum, the temple attracts devotees and tourists alike. The temple’s lively festivals, daily rituals, and traditional music and dance events offer a deep insight into Chennai’s spiritual and cultural heritage."
  },
  {
    "title": "Fort St. George",
    "description": "Fort St. George, established in 1644 by the British East India Company, is a historic landmark and administrative center in Chennai. It houses St. Mary’s Church, the Tamil Nadu Legislative Assembly, and a museum displaying colonial artifacts. Visitors can explore the fort’s ramparts, bastions, and exhibits, experiencing Chennai’s colonial history and military architecture."
  },
  {
    "title": "Santhome Cathedral Basilica",
    "description": "Santhome Cathedral Basilica, a majestic Gothic-style church, is built over the tomb of St. Thomas, one of Jesus Christ’s apostles. With beautiful stained-glass windows, elegant interiors, and serene surroundings, it attracts pilgrims and tourists alike. The church is both a spiritual center and a significant historical landmark, reflecting the Christian heritage of Chennai."
  },
  {
    "title": "Guindy National Park",
    "description": "Guindy National Park, located within Chennai city limits, is one of India’s smallest national parks. It is home to deer, blackbucks, exotic birds, and reptiles, and also features a Snake Park and Children’s Park. The park offers walking trails, picnic areas, and peaceful green spaces, making it ideal for families, wildlife enthusiasts, and students looking for nature amidst the urban environment."
  },
  {
    "title": "Valluvar Kottam",
    "description": "Valluvar Kottam is a monument dedicated to the famous Tamil poet and philosopher Thiruvalluvar. Its grand chariot-shaped auditorium and intricate stone carvings depict his literary works. The site serves as a cultural landmark and a center for literary and artistic appreciation, drawing visitors interested in Tamil culture, history, and architecture."
  },
  {
    "title": "Elliot’s Beach",
    "description": "Elliot’s Beach, located in Besant Nagar, is a serene coastal spot known for its clean sands, calm waters, and beautiful sunsets. Unlike Marina Beach, it is quieter and less crowded, making it ideal for evening walks, family outings, and leisure activities. Local cafés and eateries nearby add to the beach’s charm, offering a relaxing seaside experience."
  },
  {
    "title": "Theosophical Society",
    "description": "The Theosophical Society in Adyar is a sprawling campus with lush gardens, century-old trees, and historical buildings. It is a center for spiritual study, meditation, and philosophical discussions. Visitors can enjoy serene walks, birdwatching, and the famous Adyar Banyan Tree, experiencing a calm and reflective environment within the bustling city."
  },
  {
    "title": "Chennai Rail Museum",
    "description": "Chennai Rail Museum highlights the evolution of Indian railways, featuring vintage locomotives, carriages, photographs, and interactive exhibits. The museum offers miniature train rides, making it educational and entertaining for families, students, and railway enthusiasts. Visitors gain insight into India’s railway heritage while enjoying hands-on learning experiences."
  },
  {
    "title": "Semmozhi Poonga",
    "description": "Semmozhi Poonga is a botanical garden in central Chennai, featuring themed gardens, walking paths, landscaped lawns, and exotic plant species. It is perfect for morning walks, photography, and peaceful relaxation. The garden provides a refreshing green retreat amidst Chennai’s busy urban environment, ideal for families, nature lovers, and tourists."
  }
],


"services": [
{
"name": "ITPC Staff Shuttle",
"description": "ITPC Staff Shuttle provides high-capacity, technology-enabled shuttle services designed specifically for employees working at ITPC and surrounding IT zones. With AC minibuses, vans, optimized multi-route planning, GPS tracking, automated attendance, and strict safety protocols, it ensures smooth, reliable, and efficient transport for large teams across all shifts."
},
{
"name": "Corporate Fleet ITPC",
"description": "Corporate Fleet ITPC offers end-to-end fleet outsourcing solutions for IT companies, corporate offices, and technology parks around ITPC. The service includes sedans, SUVs, employee shuttles, and executive cars, supported by driver management, fleet maintenance, compliance tracking, and 24/7 coordination for seamless corporate mobility operations."
},
{
"name": "Employee Commute ITPC",
"description": "Employee Commute ITPC delivers structured, dependable transportation for IT and corporate employees traveling to and from the ITPC region. With intelligent routing, real-time tracking, multi-shift compatibility, and trained chauffeurs, it guarantees safe, punctual, and comfortable commuting for workforces of all sizes."
},
{
"name": "Business Cab ITPC",
"description": "Business Cab ITPC provides superior-quality corporate travel services for executives, managers, and business visitors. Featuring premium vehicles, experienced chauffeurs, fast dispatching, and a professional travel environment, it is ideal for client meetings, airport runs, and inter-office travel within Chennai’s IT corridors."
},
{
"name": "Monthly Cab ITPC",
"description": "Monthly Cab ITPC offers cost-effective long-term cab contracts for companies operating around the ITPC area. The service includes dedicated vehicles, driver scheduling, maintenance handling, smart routing, GPS tracking, and uninterrupted service reliability, making it ideal for organizations with continuous commute requirements."
},
{
"name": "Affordable ITPC Cab",
"description": "Affordable ITPC Cab delivers budget-friendly transportation solutions for employees and corporate staff working in and around ITPC. Without compromising safety or comfort, it offers optimized routes, trained drivers, clean vehicles, and efficient operations perfect for startups, SMEs, and mid-sized IT offices."
},
{
"name": "Best Corporate Cab ITPC",
"description": "Best Corporate Cab ITPC ensures premium-quality corporate travel with top-tier sedans and SUVs, professionally trained chauffeurs, strict safety procedures, and superior ride comfort. Built for executives and business travelers, this service guarantees a smooth, elite, and punctual mobility experience across Chennai’s IT corridors."
},
{
"name": "Outstation Cab ITPC",
"description": "Outstation Cab ITPC provides reliable long-distance travel solutions for business trips, client visits, factory tours, executive movement, and intercity travel from ITPC. The service includes comfortable sedans/SUVs, expert chauffeurs, interstate permits, and real-time trip monitoring to ensure safe, professional, and timely outstation travel."
},
{
"name": "Sedan Cab ITPC",
"description": "Sedan Cab ITPC offers premium, well-maintained sedans ideal for manager travel, airport transfers, executive movement, and daily commuting. With plush interiors, professional drivers, and punctual service, it ensures a refined and comfortable travel experience for corporate users working in and around ITPC."
},
{
"name": "SUV Cab ITPC",
"description": "SUV Cab ITPC provides spacious, high-performance SUVs ideal for senior executives, team movement, industrial visits, or long-distance travel. With enhanced safety features, trained chauffeurs, and superior ride comfort, the service delivers a premium travel experience for corporate clients requiring high-capacity vehicles."
},
{
"name": "Office Pickup Drop ITPC",
"description": "Office Pickup Drop ITPC offers structured pickup and drop solutions for employees across fixed, flexible, and rotating shift schedules. Supported by GPS tracking, safety monitoring, route optimization, and well-trained drivers, it ensures timely, hassle-free, and secure daily commuting for ITPC staff."
},
{
"name": "Employee Mobility ITPC",
"description": "Employee Mobility ITPC provides end-to-end workforce mobility solutions with route planning, live tracking, safety compliance, driver management, and flexible transport models. Designed for companies with varying workforce sizes, it ensures reliable, efficient, and scalable mobility across all ITPC commuting zones."
},
{
"name": "Company Transport ITPC",
"description": "Company Transport ITPC offers complete corporate transportation management including employee commute, executive car services, shuttle operations, and visitor movement. With centralized coordination, professional chauffeurs, fleet maintenance, and safety-first operations, it delivers seamless daily transport support for ITPC-based enterprises."
},
{
"name": "Corporate Shuttle ITPC",
"description": "Corporate Shuttle ITPC delivers organized, high-capacity corporate shuttle services designed for large workforce movement. With intelligent route mapping, multi-shift support, GPS-enabled monitoring, and adherence to strict safety norms, it ensures smooth, reliable, and efficient employee transport for companies operating in ITPC."
},
{
"name": "IT Park Cab Chennai",
"description": "IT Park Cab Chennai provides specialized cab services tailored for IT employees traveling to major tech hubs including ITPC. With modern cars, trained chauffeurs, smart dispatch, GPS tracking, and multi-shift operability, it ensures safe, punctual, and comfortable transportation across Chennai’s IT parks and corporate destinations."
}
],

"tableData": [
["ITPC Staff Shuttle", "Corporate Fleet ITPC"],
["Employee Commute ITPC", "Business Cab ITPC"],
["Monthly Cab ITPC", "Affordable ITPC Cab"],
["Best Corporate Cab ITPC", "Outstation Cab ITPC"],
["Sedan Cab ITPC", "SUV Cab ITPC"],
["Office Pickup Drop ITPC", "Employee Mobility ITPC"],
["Company Transport ITPC", "Corporate Shuttle ITPC"],
["IT Park Cab Chennai", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in International Tech Park Chennai (ITPC)",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers reliable corporate cab services in International Tech Park Chennai (ITPC), ensuring smooth and efficient transportation for employees and business executives."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs across ITPC and nearby corporate hubs, helping professionals reach their offices, meetings, and client locations on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring a comfortable and secure commuting experience for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable corporate travel in ITPC."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible and scalable cab rental plans tailored to meet the commuting requirements of companies and employees in International Tech Park Chennai."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our travel support team is available round-the-clock to handle bookings, emergencies, and route adjustments, ensuring uninterrupted corporate transportation."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, providing secure, clean, and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is streamlined with our easy booking system and dependable coordination, making employee transportation hassle-free for HR and admin teams."
  }
]





































  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in International Tech Park Chennai (ITPC)?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers dependable and professional corporate cab services for companies operating in International Tech Park Chennai (ITPC).',
  },
  {
    question: 'What types of corporate cab services are available in ITPC?',
    answer: 'We provide employee transportation, corporate pickups and drops, shuttle services, airport transfers, and complete fleet management solutions.',
  },
  {
    question: 'Do you support daily employee commute services for ITPC companies?',
    answer: 'Yes, we offer daily commute services with optimized routes, timely pickups, and multi-shift transportation for employees working in ITPC.',
  },
  {
    question: 'How can companies book corporate cab services in ITPC?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'What types of vehicles do you offer for corporate travel in ITPC?',
    answer: 'We provide hatchbacks, sedans, SUVs, Innova Crysta, luxury cars, and tempo travellers based on corporate requirements.',
  },
  {
    question: 'Do you provide long-term corporate cab contracts for ITPC offices?',
    answer: 'Yes, we offer monthly, quarterly, and annual transportation contracts with flexible pricing and end-to-end fleet management.',
  },
  {
    question: 'Are your corporate cabs equipped with safety and tracking features?',
    answer: 'All vehicles are GPS-enabled, sanitized frequently, and driven by trained and background-verified chauffeurs to ensure maximum safety.',
  },
  {
    question: 'Do you support night shift and rotational shift cab services in ITPC?',
    answer: 'Absolutely. We provide transportation for night shifts, early morning shifts, and rotational shift schedules for corporate employees.',
  },
  {
    question: 'What payment options are available for corporate cab services in ITPC?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. R. Shanmugam',
    feedback: 'Reliable corporate cab service for our ITPC office. Clean cars, punctual drivers, and smooth coordination.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Swaminathan',
    feedback: 'A very professional transportation partner. Our employees are extremely satisfied with their service quality and timeliness.',
    rating: 5,
  },
];







































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in International Tech Park Chennai (ITPC)",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-itpc-chennai.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited offers professional corporate cab services in International Tech Park Chennai (ITPC), including staff shuttles, corporate fleet solutions, employee commute, business cabs, office pickup & drop, monthly cab plans, outstation trips, and executive chauffeur-driven vehicles for companies operating in ITPC.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-service-itpc-chennai"
  }
};










  return (
    <div>
<Helmet>
  <title>Corporate Cab Service in ITPC Chennai | Employee & Business Transport</title>

  <meta
    name="description"
    content="Reliable corporate cab services in International Tech Park Chennai (ITPC) including staff shuttles, corporate fleet, employee commute, business cabs, office pickup & drop, monthly cab plans, outstation trips, and executive chauffeur-driven vehicles."
  />

  <meta
    name="keywords"
    content="ITPC Staff Shuttle, Corporate Fleet ITPC, Employee Commute ITPC, Business Cab ITPC, Monthly Cab ITPC, Affordable ITPC Cab, Best Corporate Cab ITPC, Outstation Cab ITPC, Sedan Cab ITPC, SUV Cab ITPC, Office Pickup Drop ITPC, Employee Mobility ITPC, Company Transport ITPC, Corporate Shuttle ITPC, IT Park Cab Chennai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/71.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceininternationaltechpark;